module.exports = __webpack_public_path__ + "img/mina.71e3a235.png";